export default "__VITE_ASSET__B8eWdglc__"